<template>
  <div class="team">

      <v-container>

          <v-layout wrap>

              <v-flex xs12 md6 class="mb-3"> <!--Flex Box for the image containers-->

                  <v-layout column justify-center align-center>

                    <v-flex xs12>
                        <v-responsive>
                            <v-avatar size="300">
                                <v-img :src="TeamOne"></v-img>
                            </v-avatar>
                        </v-responsive>
                    </v-flex>

                    <v-flex>

                        <v-layout column justify-center align-center>

                            <v-flex>
                                <p class="display-2 text-xs-center mt-3">{{crew1.name}}</p>
                            </v-flex>

                            <v-flex>
                                <p class="headline text-xs-center text-weight-light">{{crew1.role}}</p>
                            </v-flex>
                        </v-layout>

                    </v-flex>

                    <v-flex>

                        <v-layout row wrap justify-center align-center>

                                <v-btn large class="cyan lighten-3 white--text" @click="reRoute(crew1.github)">
                                    <v-icon left>public</v-icon>
                                    <span>Github</span>
                                </v-btn>

                                <v-btn large class="cyan lighten-3 white--text" @click="reRoute(crew1.instagram)">
                                    <v-icon left>public</v-icon>
                                    <span>Instagram</span>
                                </v-btn>

                        </v-layout>

                    </v-flex>

                  </v-layout>

              </v-flex>

              <v-flex xs12 md6> <!--Flex Box for the image containers-->

                  <v-layout column justify-center align-center>

                    <v-flex xs12>
                        <v-responsive>
                            <v-avatar size="300">
                                <v-img :src="TeamTwo"></v-img>
                            </v-avatar>
                        </v-responsive>
                    </v-flex>

                    <v-flex>

                        <v-layout column justify-center align-center>

                            <v-flex>
                                <p class="display-2 text-xs-center mt-3">{{crew2.name}}</p>
                            </v-flex>

                            <v-flex>
                                <p class="headline text-xs-center text-weight-light">{{crew2.role}}</p>
                            </v-flex>
                        </v-layout>

                    </v-flex>

                    <v-flex>

                        <v-layout row wrap justify-center align-center>

                                <v-btn large class="cyan lighten-3 white--text" @click="reRoute(crew2.github)">
                                    <v-icon left>public</v-icon>
                                    <span>Github</span>
                                </v-btn>

                                <v-btn large class="cyan lighten-3 white--text" @click="reRoute(crew2.instagram)">
                                    <v-icon left>public</v-icon>
                                    <span>Instagram</span>
                                </v-btn>

                        </v-layout>

                    </v-flex>

                  </v-layout>
              </v-flex>

          </v-layout>

      </v-container>

  </div>
</template>

<script>
import TeamOne from '@/assets/crew2.jpg'
import TeamTwo from '@/assets/crew1.jpg'
export default {
  name: 'TeamPage',
  props: {
      slogan: String
  },
  data () {
      
      return {
          TeamOne: TeamOne,
          TeamTwo: TeamTwo,
          crew1: {name:"Kelii McCrary",role:"Programmer/Vue Expert",github:"https://github.com/WildcherryBazzaire",instagram:"https://www.instagram.com/itsme_kelii/"},
          crew2: {name:"Jarren Calizo",role:"Designer/Creator",github:"https://github.com/AlohaJarren",instagram:"https://www.instagram.com/aloha_jxrren/"}
      }
  },
  methods: {
      reRoute: function(link) {
          window.open(link, "_blank")
      }
  }
}
</script>